import React from 'react';
import { states } from '@/constants/lifecycle';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetAttachmentDeletionDialog = ({ theme }) => {
  const { results } = Selectors.useDatasetAttachmentDeletionDialog();
  const hide = Events.useHideDeleteDatasetAttachment();
  const deleteData = Events.useDeleteDatasetAttachment();
  return (
    <ActionDialogContent
      inProgress={results.some(({ destroyStatus }) => destroyStatus === states.PENDING)}
      items={results}
      hide={hide}
      theme={theme}
      onSubmit={deleteData}
      entity="dataset.attachment"
      entities="dataset.attachments"
      className="aridhia-dataset-attachment-deletion-dialog"
    />
  );
};

export default DatasetAttachmentDeletionDialog;
